import "./card-group.scss";

export default (props) => {
  const {
    error,
    displayError,
    message,
    helpertext,
    label,
    options,
    type,
    ...inputProps // TODO: Remove style and classname??
  } = props;
  const { value } = inputProps;

  // TODO: Fix radio button not filled in, ony part of card clickable?
  const CardSelect = (option) => {
    return (
      <a
        htmlFor={`${props.name}.${option.value}`}
        className={`card-select card xs clickable elevated level-0 ${
          value === option.value ? "selected level-4" : ""
        }`}
      >
        <div style={{ paddingBottom: "8px", alignSelf: "flex-start" }}>
          <label
            className={`input input-${
              type === "checkbox" ? "checkbox" : "radio"
            }`}
            tabIndex="0"
          > 
            <div className="group" key={option.value}>
              <input
                {...inputProps}
                type={type || "radio"}
                key={`${props.name}.${option.value}`}
                id={`${props.name}.${option.value}`}
                name={props.name}
                value={option.value}
                checked={value === option.value}
              />
              {type !== "checkbox" ? (
                <span className="svg-radio">
                  <svg
                    className="svg"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                  >
                    <circle className="fill" cx="12" cy="12" r="11"></circle>
                    <circle className="stroke" cx="12" cy="12" r="11"></circle>
                  </svg>
                </span>
              ) : (
                <span className="svg-checkbox">
                  <svg
                    className="svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <rect
                        className="fill"
                        height="20"
                        rx="2"
                        width="20"
                        x="2"
                        y="2"
                      ></rect>
                      <polyline
                        className="stroke checkbox-checked"
                        points="7 13 10 16 17 8"
                      ></polyline>
                    </g>
                  </svg>
                </span>
              )}

              <h4 className="label-inline text lead">{option.label}</h4>
            </div>
          </label>
        </div>
        {option.description && (
          <div
            style={{
              paddingBottom: "20px",
              flexGrow: "2",
              paddingLeft: "20px",
            }}
          >
            <div
              className="text base"
              dangerouslySetInnerHTML={{ __html: option.description }}
            />
          </div>
        )}
      </a>
    );
  };

  return (
    <fieldset
      className={`input-checkbox-group ${props.className || ""}`}
      style={props.style}
    >
      <legend className="label">{label}</legend>
      <span id={`${props.id || props.name}_help`} className="helpertext">
        {helpertext}
      </span>

      <div
        style={{
          display: "flex",
          minWidth: "100%",
          flexWrap: "wrap",
          gap: "20px",
        }}
      >
        {options && options.map((option, i) =>   <CardSelect key={`${props.name}_${option.value}`} {...option} />        )}
      </div>

      {displayError && error ? (
        <span className="input error">
          <p id={`${props.id || props.name}_error`} className="message error">
            <span
              className="icon xsmall"
              style={{
                WebkitMaskImage:
                  "url(https://static.tui.com/assets/v2/icons/tui-light/exclamation-mark-circled-filled.svg)",
                maskImage:
                  "url(https://static.tui.com/assets/v2/icons/tui-light/exclamation-mark-circled-filled.svg)",
                color: "currentColor",
              }}
            ></span>
            {error}
          </p>
        </span>
      ) : (
        <span className="input">
          <p id={`${props.id || props.name}_message`} className="message">
            {message}
          </p>
        </span>
      )}
    </fieldset>
  );
};
